<template>
  <v-page>
    <v-link to="/me/submissions">
      <toolbar class="mb-3" :logo="false">
        <template v-slot:left>
          <span v-if="form" class="v-toolbar__text">
            {{ form ? form.title : "..." }}
          </span>
        </template>
      </toolbar>
    </v-link>

    <div v-if="isLoading" class="d-flex justify-content-center py-4">
      <v-loader />
    </div>
    <template v-else>
      <list boxed>
        <template v-for="(submission, i) in submissions">
          <list-item
            :key="i"
            chevron
            @click="() => chooseSubmission(submission.id)"
          >
            <div class="v-list-item__title --centered ml-1">
              <b class="mr-2">{{ i + 1 }}</b>
              <small class="time-ago-badge mr-1">
                {{ timeAgo(submission.created_at) }}
              </small>
              <small class="text-grey-60">
                {{ toDateTime(submission.created_at, "MMM D, YYYY, hh:mm") }}
              </small>
            </div>
          </list-item>
        </template>

        <infinite-pagination
          list-key="submissions"
          :path="submissionsPath"
          @loaded="handleLoaded"
        />
      </list>
    </template>
  </v-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import { toDateTime, timeAgo } from "@/lib/date-utils"

import List from "@/components/List"
import ListItem from "@/components/ListItem"
import Toolbar from "@/components/Toolbar"

export default {
  components: {
    List,
    ListItem,
    Toolbar,
    InfinitePagination: () => import("@/components/InfinitePagination")
  },

  data() {
    return {
      submissions: [],
      form: null,
      isLoading: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),

    // get form id from route params
    formId() {
      return this.$route.params.formId
    },

    submissionsPath() {
      return `/forms/${this.formId}/submissions`
    }
  },

  methods: {
    toDateTime,
    timeAgo,

    ...mapActions("forms", ["fetchAllFormSubmissions"]),

    chooseSubmission(id) {
      this.$router.push(`/me/forms/${this.formId}/submissions/${id}`)
    },

    handleLoaded({ list, form }) {
      this.form = form
      this.submissions = [...this.submissions, ...list]
    }
  }
}
</script>
